import { v4 as uuidv4 } from 'uuid'

import { MixRadio } from './mixRadio'

export class Mix {
	public id: number
	// While it is not used in the API, it is used to identify the mix internally
	public key: string
	public title: string

	public mixRadios: MixRadio[]

	constructor(data: {
		id: number
		key: string
		title: string
		mixRadios: MixRadio[]
	}) {
		this.id = data.id
		this.key = data.key
		this.title = data.title
		this.mixRadios = data.mixRadios
	}

	static create(data: Partial<Mix>): Mix {
		const defaultData = {
			id: 0,
			key: uuidv4(),
			title: '',
			mixRadios: [],
		}

		return new Mix({
			...defaultData,
			...data,
		})
	}

	/**
	 * Return true if the mix is simple. In other words, if it is a single playlist (no mixing among playlists)
	 *
	 * While it is not used in the app or API, it is used to identify the mix type in the UI and keep simple
	 * for the user while we make our transition to the schedules/playlists.
	 */
	isSimple(): boolean {
		return this.mixRadios.length === 1
	}
}
